import { render } from "./RecommendMusicModal.vue?vue&type=template&id=7855dce2&scoped=true"
import script from "./RecommendMusicModal.vue?vue&type=script&lang=js"
export * from "./RecommendMusicModal.vue?vue&type=script&lang=js"

import "./RecommendMusicModal.vue?vue&type=style&index=0&id=7855dce2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7855dce2"]])

export default __exports__